// Shows a Google icon only once the font has turned its name into a glyph.
// An unknown name stays wider than one glyph, so it is removed instead of showing as text.
(() => {
  const check = (root = document) => {
    root.querySelectorAll('.icon--google:not([data-ready])').forEach((icon) => {
      const glyph = icon.querySelector('.icon__glyph');
      if (!glyph) return;
      if (glyph.scrollWidth > glyph.clientWidth * 1.2) icon.remove();
      else icon.setAttribute('data-ready', '');
    });
  };
  // speed: the icon font is asked for with only the icon names on the page (icon_names, a few KB instead of 0.5 MB).
  // New names (theme editor, re-rendered parts) load a bigger set; the old stylesheet goes once the new one is in.
  // If Google refuses the request, the whole font loads as before.
  const FONT = 'https://fonts.googleapis.com/css2?family=Material+Symbols+Rounded:opsz,wght,FILL,GRAD@24,400,0..1,0&display=block';
  const names = new Set();
  let link = null;
  let full = false;
  let pending = Promise.resolve();
  const collect = (root) => {
    const found = [];
    const scan = (node) => node.querySelectorAll('.icon--google .icon__glyph').forEach((glyph) => {
      const name = glyph.textContent.trim();
      if (/^[a-z0-9_]+$/.test(name) && !names.has(name) && !found.includes(name)) found.push(name);
    });
    scan(root);
    root.querySelectorAll('template').forEach((template) => scan(template.content));
    return found;
  };
  const add = (href) => new Promise((done) => {
    const el = document.createElement('link');
    el.rel = 'stylesheet';
    el.href = href;
    el.addEventListener('load', () => done(el), { once: true });
    el.addEventListener('error', () => { el.remove(); done(null); }, { once: true });
    setTimeout(() => done(el), 8000);
    document.head.append(el);
  });
  const swap = (el) => { if (el) { link?.remove(); link = el; } };
  const sheet = (root = document) => {
    if (full) return pending;
    const found = collect(root);
    if (!found.length) return pending;
    found.forEach((name) => names.add(name));
    const href = `${FONT}&icon_names=${[...names].sort().join(',')}`;
    pending = pending
      .then(() => add(href))
      .then((el) => {
        if (el) return swap(el);
        full = true;
        return add(FONT).then(swap);
      });
    return pending;
  };
  window.themeIcons = { load: (root) => sheet(root) };
  // right after the stylesheet switches on, the browser may not have registered the font yet: retry until it has (max 5 s)
  const font = async () => {
    for (let i = 0; i < 50; i++) {
      const faces = await document.fonts.load('24px "Material Symbols Rounded"').catch(() => []);
      if (faces.length) return;
      await new Promise((r) => setTimeout(r, 100));
    }
  };
  const run = (root) => sheet(root).then(font).then(() => check(), () => check());
  // icons on the page or waiting in a <template> (shown later by a script): load the font for them now
  if (collect(document).length) run();
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('.icon--google')) run(event.target);
  });
  // product parts re-rendered after a variant change (assets/product.js) and the re-rendered cart drawer
  // (assets/cart-drawer.js) can bring new icons
  ['product:rendered', 'cart:updated'].forEach((name) => document.addEventListener(name, () => {
    if (document.querySelector('.icon--google:not([data-ready])')) run();
  }));
})();
